import { useEffect, useState, useMemo } from 'react'
import { Panel} from "@ui5/webcomponents-react";
import axios from 'axios'
import { MaterialReactTable, useMaterialReactTable } from 'material-react-table'
import Container from '@mui/material/Container';
import Paper from '@mui/material/Paper';
import { useTableStyles } from '../utils/tableStyles'
import { useTheme } from '../utils/ThemeContext'
import '../styles/MaterialTableStyles.css';


  const Skins = () => {
    const { theme } = useTheme();
    const { panelBackgroundColor, muiTableBodyCellSx, muiTableHeadCellSx, muiPaginationSx, muiTablePaperSx, muiBottomToolbarSx } = useTableStyles();
    const [skinsNetTotalData, updateSkinsNetTotalData] = useState('')
    const [skinsNetData, updateSkinsNetData] = useState([])
    const [skinsGrossTotalData, updateSkinsGrossTotalData] = useState('')
    const [skinsGrossData, updateSkinsGrossData] = useState([])
    const [loading, isLoading] = useState(false)
    
    //get skins data
    useEffect(() => {
      isLoading(true)
      getData()
    }, [])

    async function getData() {
      await axios.get(`api/public/getSkinsResults.php?year=${process.env.REACT_APP_CURRENT_YEAR}`)
      .then((response) => {
        updateSkinsNetData(response.data.netSkins);
        updateSkinsGrossData(response.data.grossSkins);
        updateSkinsNetTotalData(response.data.totalNet);
        updateSkinsGrossTotalData(response.data.totalGross);
      }).catch((error) =>{
        console.error("Error fetching data: ", error)
      }).finally(() => {
        isLoading(false)
      })
    }

    // eslint-disable-next-line
    const columns = useMemo(
    () => [
              {
                header: 'Name',
                accessorKey: 'name',
                size: 150,
                Cell: ({renderedCellValue}) => (
                  <span style={{ fontWeight: 'bold', color: theme.primary }}>{renderedCellValue}</span>
                )
              },
              {
                header: 'Won',
                accessorKey: 'numSkins',
                size: 100
              },
              {
                header: 'Amount',
                accessorKey: 'amount',
                size: 90
              }
            ],
    );

    const tableNetSkins = useMaterialReactTable({
      columns,
      data: skinsNetData,
      state: {isLoading: loading},
      enableColumnPinning: true,
      enableStickyHeader: true,
      enableTopToolbar: false,
      enableColumnActions: false,
      initialState: { density: 'compact' },
      layoutMode: 'grid',
      muiTableBodyCellProps: {
        sx: muiTableBodyCellSx,
      },
      muiTableHeadCellProps: {
        sx: muiTableHeadCellSx,
      },
      muiTablePaperProps: { sx: muiTablePaperSx },
      muiBottomToolbarProps: { sx: muiBottomToolbarSx },
      muiPaginationProps: {
        showFirstButton: false,
        showLastButton: false,
        sx: muiPaginationSx,
      }
    },[skinsNetData]);

    const tableGrossSkins = useMaterialReactTable({
      columns,
      data: skinsGrossData,
      state: {isLoading: loading},
      enableTopToolbar: false,
      enableColumnPinning: true,
      enableStickyHeader: true,
      enableColumnFilters: false,
      enableHiding: false,
      enableDensityToggle: false,
      enableFullScreenToggle: false,
      enableColumnActions: false,
      enablePagination: false,
      initialState: { density: 'compact' },
      layoutMode: 'grid',
      muiTableBodyCellProps: {
        sx: muiTableBodyCellSx,
      },
      muiTableHeadCellProps: {
        sx: muiTableHeadCellSx,
      },
      muiTablePaperProps: { sx: muiTablePaperSx },
    },[skinsGrossData]);


    return(
      <>
            <Panel stickyHeader collapsed style={{backgroundColor: panelBackgroundColor}} onToggle={function _a(){}} headerText={"$2 Skins (Total Amount: $" + skinsNetTotalData + ")"}>
              <Container>
                <Paper>
                <MaterialReactTable  style={{width: "auto"}} table={tableNetSkins} />
                </Paper>
              </Container>
            </Panel>
            <Panel stickyHeader collapsed style={{backgroundColor: panelBackgroundColor}} onToggle={function _a(){}} headerText={"$5 Skins (Total Amount: $" + skinsGrossTotalData + ")"}>
                <Container>
                  <MaterialReactTable table={tableGrossSkins} />
                </Container>
            </Panel>
     </>
    )
  }

  
  export default Skins;